import karteCustonEventClient from '../common/karte/custom_event';

document.addEventListener('DOMContentLoaded', () => {
  const bulkEditDiv = document.getElementById('staff_store_group_relationships_bulk_edit');
  if (bulkEditDiv == null) {
    return;
  }

  const allCheckBox = document.getElementById('staff_store_group_relationship_all_check') as HTMLInputElement;
  const choicesArea = document.querySelector('.staff-choices-area') as HTMLElement;
  const allCheckLabelTitle = document.querySelector('.all-check-label-title') as HTMLElement;

  allCheckBox.addEventListener('change', () => {
    const checkboxes = choicesArea.querySelectorAll('input');
    checkboxes.forEach(checkbox => {
      (checkbox as HTMLInputElement).checked = allCheckBox.checked;
    });
    if (allCheckBox.checked) {
      allCheckLabelTitle.innerText = '全てのチェックを外す';
    } else {
      allCheckLabelTitle.innerText = '全てにチェックする';
    }
  });

  const sendKarteEvent = (event_name: string, content_name: string, message: string) => {
    // 更新したことをKARTEに通知
    karteCustonEventClient.sendEvent({
      event_name: event_name,
      content_name: content_name,
      message: message
    });
  }

  // 更新時に実行
  bulkEditDiv.addEventListener('submit', () => {
    // KARTEに登録イベントを送信
    sendKarteEvent(
      'update_content',
      'staff_store_group_relationships',
      '店舗グループのスタッフ割り当てを更新しました'
    );
  })
});
